<template>
  <div
    v-if="isLoading"
    class="LKReportsRoadmapDirectionEventStatisticsMenuLinks is-loading"
  >
    <LKProgressCircular />
  </div>

  <div
    v-else-if="!list.length"
    class="LKReportsRoadmapDirectionEventStatisticsMenuLinks"
    v-text="'Список пуст'"
  />
  <div v-else class="LKReportsRoadmapDirectionEventStatisticsMenuLinks">
    <v-text-field
      v-if="showSearch"
      v-model="search"
      single-line
      hide-details
      prepend-inner-icon="mdi-magnify"
    />
    <v-list dense>
      <template v-for="(item, index) in filteredList">
        <v-divider
          v-if="index"
          :key="`${index}-divider`"
        />
        <v-list-item
          :key="index"
          :to="getLink(item.id)"
          link
          dense
          target="_blank"
          class="LKReportsRoadmapDirectionEventStatisticsMenuLinks__item"
        >
          <div class="LKReportsRoadmapDirectionEventStatisticsMenuLinks__item__row">
            Регион: <b>{{ item.region_name }}</b>
          </div>
          <div class="LKReportsRoadmapDirectionEventStatisticsMenuLinks__item__row">
            Муниципалитет: <b>{{ item.municipality_name }}</b>
          </div>
          <div class="LKReportsRoadmapDirectionEventStatisticsMenuLinks__item__row">
            ОО: <b>{{ item.name }}</b>
          </div>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<script>
import memoize from 'lodash/memoize'
import { ReportsApi } from '@/api/resources'
import { LK_ROADMAPS_FEED_ROUTES } from '@/views/LKRoadmapsFeed/utils'

import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'

const STATUS_MAPPING = {
  need_works: 'needs_work',
}

export default {
  name: 'LKReportsRoadmapDirectionEventStatisticsMenuLinks',
  components: {
    LKProgressCircular,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    roadmapId: {
      type: [Number, String],
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    search: '',
    list: [],
  }),
  computed: {
    showSearch() {
      return this.list.length > 1
    },
    filteredList() {
      if (!this.search) {
        return this.list
      }
      const lowerCasedSearch = (this.search || '').toLowerCase()
      return this.list.filter(({ searchValue }) => searchValue.includes(lowerCasedSearch))
    },
  },
  created() {
    this.init()
    this.getLink = memoize(this.getLink)
  },
  methods: {
    async init() {
      this.isLoading = true
      let promise

      switch (this.data.type) {
        case 'roadmap_direction':
          promise = this.getDirections()
          break

        case 'base_event':
          promise = this.getEvents()
          break

        default:
          // eslint-disable-next-line no-console
          console.error(`[App warn]: type "${this.data.type}" do not support`)
      }

      try {
        const { data } = await promise
        this.list = data.map((item) => ({
          ...item,
          searchValue: `${item.name} ${item.region_name} ${item.municipality_name}`.toLowerCase(),
        }))
      } catch (e) {
        this.$notice.errors(e)
      }

      this.$emit('loaded')
      this.isLoading = false
    },
    getDirections() {
      const api = new ReportsApi()
      let isConfirmed

      if (this.type.includes('unconfirmed')) {
        isConfirmed = false
      } else if (this.type.includes('confirmed')) {
        isConfirmed = true
      }

      return api.getDrilldownDirections(this.roadmapId, this.data.id, isConfirmed)
    },
    getEvents() {
      const api = new ReportsApi()
      const raw_status = this.type.replace('_count', '')
      const status = STATUS_MAPPING[raw_status] || raw_status
      return api.getDrilldownEvents(this.roadmapId, this.data.id, status)
    },
    getLink(schoolId) {
      return {
        name: LK_ROADMAPS_FEED_ROUTES.VIEW,
        params: {
          id: this.roadmapId,
          school_id: schoolId,
        },
      }
    },
  },
}
</script>

<style lang="scss">
.LKReportsRoadmapDirectionEventStatisticsMenuLinks {
  padding: 12px;
  background-color: $color-white;

  &.is-loading {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__item {
    flex-direction: column;
    align-items: flex-start;
    min-height: 10px !important;
    padding-top: 8px;
    padding-bottom: 8px;

    &__row {
      padding-bottom: 8px;
    }
  }
}
</style>
